// extracted by mini-css-extract-plugin
export var attribution = "_cy-4";
export var authorName = "_cy-5";
export var quote = "_cy-3";
export var testimonial = "_cy-2";
export var trustedBy = "_cy-0";
export var trustedByLabel = "_cy-1";